export default "__VITE_ASSET__DR2ZbkPQ__"